import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_c13u0h5ncv: FaireBrandEntity = {
  token: "b_c13u0h5ncv",
  type: "brand",
  name: "ZENZII Jewelry",
  avatarUrl:
    "https://cdn.faire.com/fastly/c8aa049490663d3598b58a40633555d7d5939ec9a01c6862e80abcb26635bee6.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/9bbcd81b8e826125c81dada5191b47353c95bb57a25c6fb5a64366e9a8aac6ea.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/c8aa049490663d3598b58a40633555d7d5939ec9a01c6862e80abcb26635bee6.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/9bbcd81b8e826125c81dada5191b47353c95bb57a25c6fb5a64366e9a8aac6ea.jpeg",
  location: "Atlanta, GA, USA",
  minimumOrderDollars: 190,
  rating: 5,
  reviewCount: 238,
  isTopShop: true,
  isInsider: true,
  description:
    "Jenny and Shawn founded ZENZII with a single mall kiosk and a mission: to drive impact in the fashion jewelry industry through bold designs and higher quality materials that produce brighter, bolder, longer-lasting products.\n\nThe couple forged their own creative path to build ZENZII into a brand that embraces individuality and celebrates authenticity. Artfully crafted with a flair for vibrant color, ZENZII jewelry is designed to elevate and amplify anyone’s personal style from simple and classic to fashion forward and statement making. Our collections have been featured in top fashion magazines, including Elle and Vogue. \n\nMade for daily wear, our pieces prioritize both style and quality to give your customers more function and versatility. All ZENZII base metals are plated with Rhodium or 18K gold. Resin and acetate styles are made from pure, undiluted material and polished to a high-gloss finish. Our jewelry is hypoallergenic, free from nickel and lead.                    \n\nBased in Atlanta, ZENZII is powered by an efficient supply chain that allows us to offer a deep inventory of stocked jewelry for same day shipping to customers around the world. To keep our collections fresh for our boutique partners, we release new styles every month. Check out our complete product offerings on https://zenziiwholesale.com.\n",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:22.501Z",
    importedBy: "entity-db-cli",
  },
};
